import { Body, Label } from '@portal/ui-library';

import styles from './TariffDescription.module.scss';

type TariffDescriptionProps = {
  description?: string;
};

export const TariffDescription = ({ description }: TariffDescriptionProps) => {
  const rawDescription = description?.replace(/\\n/g, '\n');

  const pattern = /\(f\)(.*?)\(\/f\)/g;
  const tariffName = rawDescription
    ?.match(pattern)
    ?.map((match) => match.replace(/\(f\)|\(\/f\)/g, ''));
  const tariffDescription = rawDescription?.replace(pattern, '').trim();

  return (
    <div className={styles.tariffDescription}>
      <Body small bold className="block mb-[12px]">
        {tariffName}
      </Body>
      <Label regular>{tariffDescription}</Label>
    </div>
  );
};
